import { render } from "./LogoBanner.vue?vue&type=template&id=6b67c3c3"
const script = {}

import "./LogoBanner.vue?vue&type=style&index=0&id=6b67c3c3&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__